var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrowDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A732EC6D-31B8-4F38-923E-227F79C83BCC@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333333,4.65482203 L1.42258898,0.244077682 C1.09715207,-0.0813592274 0.569514592,-0.0813592274 0.244077682,0.244077682 C-0.0813592274,0.569514592 -0.0813592274,1.09715207 0.244077682,1.42258898 L5.24407768,6.42258898 C5.56951459,6.74802589 6.09715207,6.74802589 6.42258898,6.42258898 L11.422589,1.42258898 C11.7480259,1.09715207 11.7480259,0.569514592 11.422589,0.244077682 C11.0971521,-0.0813592274 10.5695146,-0.0813592274 10.2440777,0.244077682 L5.83333333,4.65482203 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.196602231
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_00_Abonnement",
    transform: "translate(-370.000000, -484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(163.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(31.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones-/-Calendrier",
    transform: "translate(176.166667, 37.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#332E45",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDisabled);
export default __webpack_public_path__ + "static/media/dropdown_arrow_disabled.6d9336df8cdd2facf11ea4e3d3a0704e.svg";
export { ForwardRef as ReactComponent };